module.exports = __webpack_public_path__ + "static/media/2.4ed5669f.png";